import './announcements.css';
import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { useAppState } from '@/api/app-state/app-state.hooks.ts';
import { useIsEmployee } from '@/hooks/use-is-employee.ts';
import { MaintenancePage } from './maintenance-page.component.tsx';

interface Props {
  children: ReactNode;
}

/**
 * Mounted high in the tree (RootLayout). When maintenance mode is on, external
 * (and anonymous) users are blocked behind {@link MaintenancePage}; `/auth/*`
 * stays reachable so internal staff can still log in. Internal users bypass the
 * block entirely and instead see a slim "Wartungsmodus aktiv" bar so they know
 * customers are locked out.
 */
export function MaintenanceGate({ children }: Props) {
  const { data } = useAppState();
  const isEmployee = useIsEmployee();
  const { pathname } = useLocation();

  const maintenanceOn = data?.maintenance.enabled ?? false;
  const onAuthRoute = pathname === '/auth' || pathname.startsWith('/auth/');

  if (maintenanceOn && !isEmployee && !onAuthRoute) {
    return (
      <MaintenancePage
        title={data?.maintenance.title ?? 'Wartungsarbeiten'}
        message={
          data?.maintenance.message ??
          'Wir sind in Kürze wieder für Sie da.'
        }
      />
    );
  }

  return (
    <>
      {maintenanceOn && isEmployee && (
        <div className="eos-maintenance-active-bar" role="status">
          <span aria-hidden>🛠️</span>
          Wartungsmodus aktiv — externe Kunden sind derzeit ausgesperrt.
        </div>
      )}
      {children}
    </>
  );
}
